import { render, staticRenderFns } from "./userSignupModal.vue?vue&type=template&id=506b0e3d&scoped=true"
import script from "./userSignupModal.vue?vue&type=script&lang=js"
export * from "./userSignupModal.vue?vue&type=script&lang=js"
import style0 from "./userSignupModal.vue?vue&type=style&index=0&id=506b0e3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506b0e3d",
  null
  
)

export default component.exports